export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.setSwitch();
    }

    setSwitch() {
        const charactercont = document.querySelector('.character__cont');
        const switchbtn = document.querySelector('.js-character-switch');

        if (!switchbtn) return;

        switchbtn.addEventListener('click', () => {
            const charaSwitchIndex = charactercont.getAttribute('data-switch');
            const newSwitchIndex = charaSwitchIndex === '1' ? '2' : '1';
            charactercont.setAttribute('data-switch', newSwitchIndex);
        });
    }
}
